import {Directive} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {ElementRef} from '@angular/core';
import {HostListener} from '@angular/core';
import {Input} from '@angular/core';
import {OnInit} from '@angular/core';
import {Output} from '@angular/core';

const PASSWORD_TYPE = 'password';
const TEXT_TYPE = 'text';

@Directive({ selector: 'input[uiInput], textarea[uiInput]' })
export class UIInputDirective implements OnInit {

    private _sourceType: string;

    @Output()
    onBlur = new EventEmitter<void>();

    @Output()
    onFocus = new EventEmitter<void>();

    @Input()
    placeholder: string;

    @Input()
    type: string;

    get value() {
        return this._elementRef.nativeElement.value;
    }

    set value(value: string) {
        this._elementRef.nativeElement.value = value;
    }

    constructor(private _elementRef: ElementRef) {
    }

    ngOnInit(): void {
        this._sourceType = this.type;
    }

    nowPassword(): boolean {
        return (this.type === PASSWORD_TYPE);
    }

    isPassword(): boolean {
        return (this._sourceType === PASSWORD_TYPE);
    }

    togglePasswordType(): void {
        const newType = this.type === PASSWORD_TYPE ? TEXT_TYPE : PASSWORD_TYPE;
        this._elementRef.nativeElement.setAttribute('type', newType);
        this.type = newType;
    }

    @HostListener('blur')
    private _onBlur() {
        this.onBlur.emit();
    }

    @HostListener('focus')
    private _onFocus() {
        this.onFocus.emit();
    }

}